import React, { createContext, useContext } from 'react';

interface SidebarContextValue {
  sidebarOpen: boolean;
}

const SidebarContext = createContext<SidebarContextValue>({ sidebarOpen: true });

export const SidebarProvider: React.FC<{ children: React.ReactNode; sidebarOpen: boolean }> = ({
  children,
  sidebarOpen,
}) => (
  <SidebarContext.Provider value={{ sidebarOpen }}>{children}</SidebarContext.Provider>
);

export function useSidebarOpen(): boolean {
  return useContext(SidebarContext).sidebarOpen;
}
